<template>
    <div :class="['hpProgram']">
        <div class="wrapper" @click="closeProgram">
            <div class="container">

                <div class="section">
                    <div class="sessionNo">Session I</div>
                    <div class="sessionTitle">Implant Dentistry - Trends, Challenges, and Innovations</div>
                    <div>
                        <div class="sessionTime"></div>
                        <div class="sessionText"></div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style scoped>
  .hpProgram
  {
      position: fixed;
      top: 0px;left: 0px;width: 100vw;height: 100vh;
      overflow: hidden;
      background-color: #207ab9;
      color:#fff;
      z-index: 1002;
      display: grid;
      align-items: center;
      text-align: center;
      transition: all 0.6s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      pointer-events: all;
      opacity: 1;
      clip-path: inset(0px 0px 0px 0px);
  }
  .hpProgram.spOpen
  {
      pointer-events: all;
      opacity: 1;
      clip-path: inset(0px 0px 0px 0px);
  }
  .hpProgram .wrapper
  {
    width: 100vw;
    border: solid 0px white;
    height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
  }  
  .hpProgram .wrapper .container
  {
    width: 55vw;
    max-width: 1100px;
  }
.hpProgram .wrapper .container .section
  {
    width: 100%;
    height: 400px;
    border: solid 0px red;
    clear: both;
  }  

  @media (max-width: 850px) { 
    .hpProgram .wrapper .container
    {
        width: 90vw;
        max-width: 90vw;
        margin: auto;
    }

  }
  @media (hover: hover) {
  }    

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
        
    }

    /* Landscape iPad mini 1, iPad 1 and iPad 2 */
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: landscape)
    {

    }     

</style>>


<script>
export default {
    props: {
        isShow: Boolean,
    },
    methods:
    {
        closeProgram()
        {
            this.$emit("close-program");
        },
        showSpekaer(index)
        {
            //open the requested speaker information
        }
    }



};
</script>

